import { render, staticRenderFns } from "./SideDrawer.vue?vue&type=template&id=c3129544&scoped=true"
import script from "./SideDrawer.vue?vue&type=script&lang=js"
export * from "./SideDrawer.vue?vue&type=script&lang=js"
import style0 from "./SideDrawer.vue?vue&type=style&index=0&id=c3129544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3129544",
  null
  
)

export default component.exports